var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightArrow = function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 6.1,
    height: 107,
    viewBox: "0 0 6.1 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B26",
    d: "M.1 1.4 1.3 0l4.8 4.8v.4L1.3 10 0 8.6 3.6 5z"
  })));
};
export default SvgRightArrow;